import React from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';

import { getImageShopCard } from '@services/images.service';
import Image from '@components/Image';
import FormatPrice from '@shared/containers/FormatPrice';

import { ShopCartContainer, ShopCartDetail, Title } from './components';

import messages from './messages';

function ShopCard({
  shop,
  isCart,
  cartMinDeliveryAmount,
  cartShippingAmount,
  cartDeliveryTime,
  intl: { formatMessage },
  isCheckout,
}) {
  const { logo, name } = shop;

  const image = getImageShopCard({ image: logo, width: 50 });

  let { deliveryTime } = shop;

  if (cartDeliveryTime) {
    const { description } = cartDeliveryTime;
    deliveryTime = description;
  }

  const getMinDeliveryAmountMessage = formattedPrice =>
    cartMinDeliveryAmount
      ? formatMessage(messages.shopdetails_with_minDeliveryAmmount, {
          cartMinDeliveryAmount: formattedPrice,
        })
      : formatMessage(messages.shopdetails_min_delivery_amount);

  const getMinShippingMessage = formattedPrice =>
    cartShippingAmount
      ? formatMessage(messages.shopdetails_with_shipping_amount, {
          cartShippingAmount: formattedPrice,
        })
      : formatMessage(messages.shopdetails_shipping_amount);

  const deliveryTimeShowed = `${deliveryTime} · `;

  return (
    <ShopCartDetail isCart={isCart}>
      <Image ariaHidden src={image} alt={name} />
      <ShopCartContainer>
        <Title>{name}</Title>
        <div>
          <span>{deliveryTimeShowed}</span>
          {isCheckout ? null : (
            <FormatPrice value={cartShippingAmount}>
              {formattedPrice => (
                <span>
                  {getMinShippingMessage(formattedPrice)}
                  {' · '}
                </span>
              )}
            </FormatPrice>
          )}
          <FormatPrice value={cartMinDeliveryAmount}>
            {formattedPrice => (
              <span>{getMinDeliveryAmountMessage(formattedPrice)}</span>
            )}
          </FormatPrice>
        </div>
      </ShopCartContainer>
    </ShopCartDetail>
  );
}

ShopCard.propTypes = {
  shop: PropTypes.shape({
    name: PropTypes.string.isRequired,
    deliveryTime: PropTypes.string.isRequired,
    logo: PropTypes.string.isRequired,
  }),
  cartMinDeliveryAmount: PropTypes.number.isRequired,
  cartShippingAmount: PropTypes.number.isRequired,
  cartDeliveryTime: PropTypes.shape({
    description: PropTypes.string.isRequired,
    minMinutes: PropTypes.number.isRequired,
    maxMinutes: PropTypes.number.isRequired,
  }),
  isCart: PropTypes.bool,
  isCheckout: PropTypes.bool,
  intl: intlShape.isRequired,
  info: PropTypes.shape({
    pickup: PropTypes.shape({
      time: PropTypes.shape({
        maxMinutes: PropTypes.number,
      }),
      distance: PropTypes.number,
      duration: PropTypes.number,
    }),
    delivery: PropTypes.shape({
      time: PropTypes.shape({
        minMinutes: PropTypes.number,
        maxMinutes: PropTypes.number,
      }),
      shipping: PropTypes.number,
      min: PropTypes.number,
    }),
  }).isRequired,
};

ShopCard.defaultProps = {
  isCart: false,
  isCheckout: false,
};

export { ShopCard as ShopCardTest };
export default injectIntl(ShopCard);
